import { useSelector, useDispatch } from 'react-redux'
import props from '../../../../../redux/props'
import Checkbox from '../../../../UI/Checkbox/Checkbox'
import { setLocal } from '../../../../../redux/action/local'

const ToggleScreenshotMode = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const enableScreenshotMode = useSelector((s) => s[props.ENABLE_SCREENSHOT_MODE])
  const dispatch = useDispatch()

  const toggleScreenshotMode = () => {
    dispatch(setLocal(props.ENABLE_SCREENSHOT_MODE, !enableScreenshotMode))
  }

  return <Checkbox checked={enableScreenshotMode} onChange={toggleScreenshotMode} label={t.survey.analysis.concept.graph.transparency} />
}

export default ToggleScreenshotMode
